module.exports = __webpack_public_path__ + "static/media/edit.ec34e72e.svg";